import { FC } from 'react';
import RegionDetail from './RegionDetail';
import UseRegionDetail from './UseRegionDetail';

const RegionDetailContainer: FC = () => {
  return <RegionDetail {...UseRegionDetail()} />;
};

export default RegionDetailContainer;
